import { createAction, props } from '@ngrx/store';

import {
  MemberRewardPickupContent,
  MemberRewardPickupCriteria,
  MemberRewardPickupPagination
} from '../../models/member-reward-pickup';

export const memberRewardPickupClearState = createAction('[Member Reward Pickup] MemberRewardPickup clear state');
export const memberRewardPickupListRequest = createAction(
  '[Member Reward Pickup] MemberRewardPickup request List',
  props<{ payload: MemberRewardPickupCriteria }>()
);

export const memberRewardPickupListResponse = createAction(
  '[Member Reward Pickup] MemberRewardPickup response List',
  props<{ response: MemberRewardPickupPagination }>()
);

export const selectMemberRewardPickup = createAction(
  '[Member Reward Pickup] Selected MemberRewardPickup',
  props<{ data: MemberRewardPickupContent }>()
);

export const resetSelectedMemberRewardPickup = createAction(
  '[Member Reward Pickup] Clear Selected MemberRewardPickup'
);
